

//Get Cart
//http://thelottofactoryapi.azurewebsites.net/v1/cart?ApiKey=0d7965bd-f8a6-4072-a84c-4176f0ad8daf
function CartSummarySvc($resource) {
  'ngInject';
  var odataUrl = TFL_Base_Url + 'cart/summary'
  return $resource(odataUrl, {}, {
      get: { method: 'GET', params: { APIKey: '@APIKey' }, isArray: false }
  });
};

export default {
	name: "CartSummarySvc",
	fn: CartSummarySvc
}